var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',[_c('LoaderIcon',{attrs:{"has-primary-bg":true}})],1),(!_vm.small)?_c('div',{staticClass:"uppercase text-primary text-center text-sm font-bold mt-3"},[_vm._v("Loading")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }